import { useSearchParams } from "react-router-dom";
import { toParams } from "@/lib/inventory";

const list = (params, key) => (params.get(key) || "").split(",").filter(Boolean);

export const useStockFilters = () => {
  const [params, setParams] = useSearchParams();
  const filters = {
    make: params.get("make") || "",
    model: params.get("model") || "",
    minPrice: Number(params.get("minPrice")) || 0,
    maxPrice: Number(params.get("maxPrice")) || 0,
    fuel: list(params, "fuel"),
    transmission: list(params, "transmission"),
    body: list(params, "body"),
    sort: params.get("sort") || "newest",
  };

  const update = (patch) => {
    const next = { ...filters, ...patch };
    if (patch.make !== undefined && patch.make !== filters.make && patch.model === undefined) next.model = "";
    setParams(toParams(next), { replace: true });
  };

  const toggle = (key, value) =>
    update({ [key]: filters[key].includes(value) ? filters[key].filter((x) => x !== value) : [...filters[key], value] });

  const clear = () => setParams(filters.sort !== "newest" ? { sort: filters.sort } : {}, { replace: true });

  const activeCount =
    [filters.make, filters.model, filters.minPrice, filters.maxPrice].filter(Boolean).length +
    filters.fuel.length +
    filters.transmission.length +
    filters.body.length;

  return { filters, update, toggle, clear, activeCount };
};
